import { HttpErrorResponse } from "@angular/common/http";
import * as z from "zod";

export const ExceptionSchema = z.object({
  title: z.string(),
  detail: z.string(),
  status: z.number(),
});

export const ExceptionPreprocessSchema = z.preprocess((argument) => {
  if (argument instanceof HttpErrorResponse) {
    const result = ExceptionSchema.safeParse(argument.error);

    return result.success ? result.data : null;
  }

  return null;
}, ExceptionSchema);
